// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup{z-index:1031;position:fixed;top:0;left:0;bottom:0;right:0;transition:opacity 0.1s ease-in-out;flex-wrap:wrap;align-items:center;display:none;text-align:center;background-color:rgba(255,255,255,0.5)}.popup.visible{display:flex}.popup>*{margin:auto}.popup .popup-window{border:1px solid #4b607e;background-color:#fff;padding:2rem;border-radius:5px}\n", ""]);
// Exports
module.exports = exports;
